<template>
  <div>
    <div>
      <h2 class="mb-5">
        What areas are you interested in working in?
      </h2>
    </div>
    <div
      v-if="isFetchingExperienceFunctions || isFetchingUserExperienceFunctions"
    >
      <v-skeleton-loader type="list-item-three-line" />
    </div>
    <div v-else>
      <div
        v-for="(categoryItems, category) in formattedFunctions"
        :key="category"
      >
        <div class="font-weight-bold">{{ category | capitalize }}</div>
        <Checkbox
          @change="val => (jobFunctions = val)"
          :selected-values="initialSelectedJobFunctions"
          :options="categoryItems"
          isLarge
          mixed
        />
      </div>
    </div>
    <div class="d-flex justify-end">
      <PrimaryButton @click.native="nextStep" :loading="isLoading">
        Continue
      </PrimaryButton>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import Checkbox from "@/components/common/Checkbox";
import { copyState } from "@/utils/helpers";
import { USERS_NAMESPACE } from "@/store/modules/users";
import {
  ADD_USER_JOB_PREFERENCE,
  FETCH_USER_EXPERIENCE_FUNCTIONS
} from "@/store/modules/users/actions";
import {
  GET_USER_EXPERIENCE_FUNCTIONS,
  GET_IS_FETCHING_USER_EXPERIENCE_FUNCTIONS
} from "@/store/modules/users/getters";
import { EXPERIENCE_NAMESPACE } from "@/store/modules/users/experience";
import { map } from "lodash";
import { AUTH_NAMESPACE } from "@/store/modules/auth";

const { mapState } = createNamespacedHelpers(EXPERIENCE_NAMESPACE);
const {
  mapGetters: mapUserGetters,
  mapActions: mapUserActions
} = createNamespacedHelpers(USERS_NAMESPACE);
const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  name: "JobFunction",
  components: {
    PrimaryButton,
    Checkbox
  },
  props: {
    userId: String
  },
  async created() {
    await this.fetchUserExperienceFunctions(this.userData.id);
    this.jobFunctions = [...this.initialSelectedJobFunctions];
  },
  data() {
    return {
      jobFunctions: [],
      isLoading: false
    };
  },
  computed: {
    ...mapAuthState({
      userData: state => state.userData
    }),
    ...mapState(
      copyState(["isFetchingExperienceFunctions", "experienceFunctions"])
    ),
    ...mapUserGetters({
      isFetchingUserExperienceFunctions: GET_IS_FETCHING_USER_EXPERIENCE_FUNCTIONS,
      userExperienceFunctions: GET_USER_EXPERIENCE_FUNCTIONS
    }),
    initialSelectedJobFunctions() {
      return map(this.userExperienceFunctions, "id");
    },
    formattedFunctions() {
      return this.experienceFunctions.reduce(
        (formattedFunctions, { category, name, id }) => {
          const functionItem = {
            label: name,
            value: id
          };
          if (formattedFunctions[category]) {
            formattedFunctions[category].push(functionItem);
          } else {
            formattedFunctions[category] = [functionItem];
          }
          return formattedFunctions;
        },
        {}
      );
    }
  },
  methods: {
    ...mapUserActions({
      addUserJobPreference: ADD_USER_JOB_PREFERENCE,
      fetchUserExperienceFunctions: FETCH_USER_EXPERIENCE_FUNCTIONS
    }),
    async nextStep() {
      this.$emit("nextStep");
    },
    async handleUpload() {
      this.isLoading = true;
      await this.addExperienceFunctions();
      this.isLoading = false;
    },
    async addExperienceFunctions() {
      await this.addUserJobPreference({
        userId: this.userId,
        data: {
          jobPreferenceIds: this.jobFunctions,
          jobPreferenceType: "experience_function"
        }
      });
    }
  }
};
</script>

<style lang="scss"></style>
